import Card from "antd/es/card/Card";
import Brokers from "entities/Brokers";
import { get } from "lodash";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Header from "shared/components/Header";
import Search from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { StoreContext } from "shared/store";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const List = () => {
  const { user } = useContext(StoreContext);

  // const [open, setOpen] = useState(false);
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.BROKER);
  const LIST = t("LIST", { returnObjects: true });
  const [pagination, setPagination] = useState(INITIAL_VALUES);
  const [filter, setFilter] = useState({
    where: {
      organization: { id: get(user, "organization.id") },
    },
  });

  const navigate = useNavigate();

  const onSearch = (value) => {
    setPagination((prev) => ({ ...prev, skip: 0 }));
    setFilter((prev) => ({
      ...prev,
      like: {
        OR: [{ organization: { name: `%${value}%` } }],
      },
    }));
  };
  // const handleOpenModal = () => {
  //   setOpen(true);
  // };
  const buttons = [
    // {
    //   icon: <BsFileEarmarkExcel size={24} />,
    //   text: LIST.HEADER.UPLOAD,
    //   type: "primary--outlined",
    //   onClick: handleOpenModal,
    // },
    {
      icon: <MdAdd size={24} />,
      text: LIST.HEADER.SAVE,
      onClick: () => navigate(SCREENS.PRIVATE.ADMIN.BROKERS.CREATE.path),
    },
  ];

  return (
    <>
      <Header title={LIST.HEADER.TITLE} actions={buttons} />
      <Card type="simple">
        <div className="m-bottom-20 grid--4">
          <Search
            placeholder={LIST.SEARCH}
            type="search"
            onChange={({ target: { value } }) => onSearch(value)}
          />
        </div>
        <Brokers
          View={View}
          filter={{ ...filter, ...pagination }}
          setValues={setPagination}
          skip={pagination.skip || 0}
          NoData={View}
        />
      </Card>
      {/* <Upload open={open} setOpen={setOpen} onCancel={() => setOpen(false)} /> */}
    </>
  );
};

export default List;
